export default "/fr/_next/static/assets/images/video-player-sprite.5ce1afd2f4ca0392413b83f8f2305801.svg";